import React, { useState, useRef, useEffect } from "react";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import FooterSection from "../component/layout/footer";
import GroupItemThree from "../component/items/groupitemthree";
import Pagination from "../component/section/pagination";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { SyncLoader } from "react-spinners";

const CommunityPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [customImages, setCustomImages] = useState([]);
  const [groupName, setGroupName] = useState("");
  const [groupDescription, setGroupDescription] = useState("");
  const [isCreatingGroup, setIsCreatingGroup] = useState(false);
  const fileInputRef = useRef(null);
  const groupCreationRef = useRef(null);

  const [groups, setGroups] = useState([]);

  const GroupListContent = [
    { imgUrl: "assets/images/group/05.jpg" },
    { imgUrl: "assets/images/group/02.jpg" },
    { imgUrl: "assets/images/group/03.jpg" },
    { imgUrl: "assets/images/group/04.jpg" },
    { imgUrl: "assets/images/group/05.jpg" },
    { imgUrl: "assets/images/group/06.jpg" },
    { imgUrl: "assets/images/group/07.jpg" },
    { imgUrl: "assets/images/group/08.jpg" },
    { imgUrl: "assets/images/group/09.jpg" },
    { imgUrl: "assets/images/group/10.jpg" },
    { imgUrl: "assets/images/group/11.jpg" },
    { imgUrl: "assets/images/group/06.jpg" },
  ];
  const allImages = [...GroupListContent, ...customImages];

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    getGroups();
  }, []);

  useEffect(() => {
    if (allImages.length > 0 && !selectedImage) {
      setSelectedImage(allImages[0].imgUrl);
    }
  }, [allImages, selectedImage]);

  useEffect(() => {
    if (isCreatingGroup && groupCreationRef.current) {
      groupCreationRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });

      groupCreationRef.current.classList.add("highlight-animation");

      const timer = setTimeout(() => {
        groupCreationRef.current.classList.remove("highlight-animation");
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [isCreatingGroup]);

  const handleKeyDown = (e) => {
    if (allImages.length === 0) return;

    if (e.key === "ArrowRight") {
      const nextIndex = (selectedIndex + 1) % allImages.length;
      setSelectedIndex(nextIndex);
      setSelectedImage(allImages[nextIndex].imgUrl);
    } else if (e.key === "ArrowLeft") {
      const prevIndex =
        (selectedIndex - 1 + allImages.length) % allImages.length;
      setSelectedIndex(prevIndex);
      setSelectedImage(allImages[prevIndex].imgUrl);
    }
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const newImage = { imgUrl: reader.result };
        setCustomImages([...customImages, newImage]);
        setSelectedIndex(allImages.length);
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  // const handleSaveGroup = async () => {
  //   const token = localStorage.getItem("token");

  //   if (!groupName.trim()) {

  //     toast.error("Enter Group Name");
  //     return;
  //   }

  //   if(!groupDescription.trim()){
  //     toast.error("Enter Group Description");
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append("name", groupName);
  //   formData.append("title", groupName);
  //   formData.append("description", groupDescription);

  //   const file = fileInputRef.current?.files[0];
  //   if (file) {
  //     formData.append("image", file);
  //   }

  //   try {
  //     await axios.post(
  //       `${process.env.REACT_APP_MAIN_SITE_URL}/group/store`,
  //       formData,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     toast.success("Group created successfully!");
  //     setGroupName("");
  //     setGroupDescription("");
  //     setSelectedImage(null);
  //     setCustomImages([]);

  //     getGroups();
  //     if (fileInputRef.current) {
  //       fileInputRef.current.value = "";
  //     }
  //   } catch (err) {
  //     console.error("Group creation failed", err);
  //     alert("Failed to create group");
  //   }
  // };

  // const handleSaveGroup = async () => {

  //     if (isSubmitting) return;
  //   const token = localStorage.getItem("token");

  //   if (!groupName.trim()) {
  //     toast.error("Enter Group Name");
  //     return;
  //   }

  //   if (!groupDescription.trim()) {
  //     toast.error("Enter Group Description");
  //     return;
  //   }

  // setIsSubmitting(true);

  //   const formData = new FormData();
  //   formData.append("name", groupName);
  //   formData.append("description", groupDescription);

  //   const file = fileInputRef.current?.files[0];

  //   if (file) {
  //     try {
  //       const webpBlob = await convertImageToWebP(file);
  //       const webpFile = new File([webpBlob], "image.webp", {
  //         type: "image/webp",
  //       });
  //       formData.append("image", webpFile);
  //     } catch (err) {
  //       console.error("Image conversion to WebP failed", err);
  //       toast.error("Image processing failed");
  //       return;
  //     }
  //   }

  //   try {
  //     await axios.post(
  //       `${process.env.REACT_APP_MAIN_SITE_URL}/group/store`,
  //       formData,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     toast.success("Group created successfully!");
  //     setGroupName("");
  //     setGroupDescription("");
  //     setSelectedImage(null);
  //     setCustomImages([]);
  //     getGroups();

  //     if (fileInputRef.current) {
  //       fileInputRef.current.value = "";
  //     }
  //   } catch (err) {
  //     console.error("Group creation failed", err);
  //     alert("Failed to create group");
  //   }
  // };

  const handleSaveGroup = async () => {
    if (isSubmitting) return; // Prevent duplicate submissions

    const token = localStorage.getItem("token");

    if (!groupName.trim()) {
      toast.error("Enter Group Name");
      return;
    }

    if (!groupDescription.trim()) {
      toast.error("Enter Group Description");
      return;
    }

    setIsSubmitting(true); // start loading

    const formData = new FormData();
    formData.append("name", groupName);
    formData.append("description", groupDescription);

    const file = fileInputRef.current?.files[0];

    if (file) {
      try {
        const webpBlob = await convertImageToWebP(file);
        const webpFile = new File([webpBlob], "image.webp", {
          type: "image/webp",
        });
        formData.append("image", webpFile);
      } catch (err) {
        console.error("Image conversion to WebP failed", err);
        toast.error("Image processing failed");
        setIsSubmitting(false); // reset on error
        return;
      }
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_MAIN_SITE_URL}/group/store`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Group created successfully!");
      setGroupName("");
      setGroupDescription("");
      setSelectedImage(null);
      setCustomImages([]);
      getGroups();

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (err) {
      console.error("Group creation failed", err);
      alert("Failed to create group");
    } finally {
      setIsSubmitting(false);
    }
  };

  const convertImageToWebP = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = function (e) {
        img.src = e.target.result;
      };

      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        canvas.toBlob(
          (blob) => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error("WebP conversion failed"));
            }
          },
          "image/webp",
          0.8 // quality: optional (0.0 - 1.0)
        );
      };

      img.onerror = function (err) {
        reject(err);
      };

      reader.onerror = function (err) {
        reject(err);
      };

      reader.readAsDataURL(file);
    });
  };

  const handleCreateGroupClick = () => {
    setIsCreatingGroup(true);
    setTimeout(() => setIsCreatingGroup(false), 2000);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  const getGroups = async (page = 1) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_MAIN_SITE_URL}/group/list?page=${page}&per_page=6`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setGroups(response.data.data);
      setCurrentPage(response.data.current_page);
      setLastPage(response.data.last_page);
    } catch (error) {
      console.error("Failed to fetch groups:", error);
    }
  };

  const handlePageChange = (page) => {
    getGroups(page);
  };

  return (
    <div onKeyDown={handleKeyDown} tabIndex="0">
      <Header />
      <PageHeader title={"Community"} />
      <section className="group-page-section padding-tb">
        <div className="container">
          <ul className="group-search sticky-search-bar">
            <li
              className="group-count point cursor-pointer"
              onClick={handleCreateGroupClick}
            >
              <p>Create Group</p>
              <p>+</p>
            </li>
            <li className="group-count">
              <p>All Groups</p>
              <p>10+</p>
            </li>
            <li className="group-search-btn">
              <form action="/">
                <input type="text" placeholder="Search Group Name..." />
                <div className="input-button">
                  <input type="submit" value="Search Now" />
                </div>
              </form>
            </li>
          </ul>
          <div className="groups-wrapper">
            <div className="row g-4">
              <div className="col-lg-6" ref={groupCreationRef}>
                <div className="group-item lab-item style-1">
                  <div className="lab-inner d-flex flex-wrap align-items-center p-4">
                    <div
                      className="lab-thumb me-sm-4 mb-4 mb-sm-0"
                      style={{ position: "relative", cursor: "pointer" }}
                      onClick={triggerFileInput}
                    >
                      {selectedImage ? (
                        <img
                          src={selectedImage}
                          alt="group-img"
                          style={{ width: "100%", height: "auto" }}
                        />
                      ) : (
                        <div
                          style={{
                            width: "150px",
                            height: "150px",
                            backgroundColor: "#f5f5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <i
                            className="icofont-plus"
                            style={{ fontSize: "24px" }}
                          ></i>
                        </div>
                      )}

                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          backgroundColor: "rgba(0,0,0,0.5)",
                          borderRadius: "50%",
                          width: "40px",
                          height: "40px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          triggerFileInput();
                        }}
                      >
                        <i className="icofont-upload"></i>
                      </div>

                      <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleImageUpload}
                        accept="image/*"
                        style={{ display: "none" }}
                      />
                    </div>

                    <div className="lab-content">
                      <div className="mb-3">
                        <label htmlFor="groupName" className="form-label">
                          Group Name
                        </label>
                        <input
                          type="text"
                          id="groupName"
                          className="form-control text-black"
                          value={groupName}
                          onChange={(e) => setGroupName(e.target.value)}
                          placeholder="Enter group name"
                        />
                      </div>
                      <div className="mb-3">
                        <label
                          htmlFor="groupDescription"
                          className="form-label"
                        >
                          Group Description
                        </label>
                        <input
                          type="text"
                          id="groupDescription"
                          className="form-control text-black"
                          value={groupDescription}
                          onChange={(e) => setGroupDescription(e.target.value)}
                          placeholder="Enter group description"
                        />
                      </div>
                      <div className="test mt-2">
                        <button
                          className="lab-btn"
                          onClick={handleSaveGroup}
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <SyncLoader size={6} color="#000" />
                          ) : (
                            <>
                              <i className="icofont-save"></i>{" "}
                              <span className="text-black">Save Group</span>
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <GroupItemThree
                groups={groups}
                itemNumber={6}
                onGroupDeleted={getGroups}
              />
            </div>
            <Pagination
              currentPage={currentPage}
              lastPage={lastPage}
              onPageChange={handlePageChange}
            />{" "}
          </div>
        </div>
      </section>
      <FooterSection />
    </div>
  );
};

export default CommunityPage;
